export const MESSAGES = {
  REQUEST_ERROR: "Failed to fetch Purchase Order list",
  NO_REQUESTS_AVAILABLE: "No Purchase Orders Available",
  DETAIL_LOAD_ERROR: "Failed to fetch Purchase Order details",
  ITEMS_LOAD_ERROR: "Failed to fetch Purchase Order items",
  REFRESH_SUCCESS: "Purchase Order refreshed successfully",
  REFRESH_ERROR: "Failed to refresh Purchase Order",
  SITE_SEARCH_ERROR: "Failed to fetch sites",
  SITE_UPDATE_SUCCESS: "Site updated successfully",
  SITE_UPDATE_ERROR: "Failed to update site",
};

export const PO_LIST_COLUMNS = [
  "zoho_po_number",
  "vendor_name",
  "po_date",
  "delivery_date",
  "expected_delivery_date",
  "status",
  "received_status",
  "billed_status",
];

export const PO_LIST_LABELS = {
  zoho_po_number: "PO Number",
  vendor_name: "Vendor Name",
  po_date: "PO Date",
  delivery_date: "Delivery Date",
  expected_delivery_date: "Expected Delivery Date",
  status: "Status",
  received_status: "Received",
  billed_status: "Billed",
};

export const PO_INFO_LABELS = {
  zoho_po_number: "PO Number",
  vendor_name: "Vendor Name",
  po_date: "PO Date",
  delivery_date: "Delivery Date",
  expected_delivery_date: "Expected Delivery",
  site: "Site",
};

// Mirrors Zoho's `status`/`order_status` verbatim - never has a
// "ready_to_bill" value, that's tracked on billed_status instead.
export const PO_STATUS_OPTIONS = ["draft", "open", "billed", "cancelled"];

export const PO_STATUS_STYLES = {
  draft: "bg-gray-100 text-gray-700",
  open: "bg-blue-100 text-blue-700",
  billed: "bg-green-100 text-green-700",
  cancelled: "bg-red-100 text-red-700",
};

export const PO_RECEIVED_STATUS_OPTIONS = ["to_be_received", "received"];

export const PO_BILLED_STATUS_OPTIONS = [
  "to_be_billed",
  "ready_to_bill",
  "billed",
];

export const PO_RECEIVED_STATUS_STYLES = {
  to_be_received: "bg-gray-100 text-gray-700",
  received: "bg-green-100 text-green-700",
};

export const PO_BILLED_STATUS_STYLES = {
  to_be_billed: "bg-gray-100 text-gray-700",
  ready_to_bill: "bg-yellow-100 text-yellow-700",
  billed: "bg-green-100 text-green-700",
};

export const formatStatusLabel = (value) =>
  (value || "-")
    .toString()
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
